import { useMemo } from 'react';
import { CustomTabsProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import TabWithAmount from './TabWithAmount';
import { TabsWrapper } from './styles';
import './styles.scss';
import classNames from 'classnames';

const CustomTabs: React.FC<CustomTabsProps> = props => {
  const {
    items,
    width,
    height,
    className,
    style = {},
    itemGrow = true,
    hideTabsNav = false,
    borderColor = 'var(--light-pink)',
    isShowTab = false,
    ...rest
  } = props;

  const newStyle = useMemo(() => {
    return {
      ...style,
      ...createNewWidthHeightStyle({ width, height }),
    };
  }, [width, height, style]);

  const newItems = useMemo(() => {
    return items?.map(item => {
      if (item.amount) {
        return {
          ...item,
          label: (
            <TabWithAmount amount={item.amount}>{item.label}</TabWithAmount>
          ),
        };
      }
      return item;
    });
  }, [items]);

  return (
    <>
      <TabsWrapper
        {...rest}
        style={newStyle}
        items={newItems}
        borderColor={borderColor}
        isHideTab={!isShowTab}
        className={classNames(className, { itemGrow, hideTabsNav })}
      />
    </>
  );
};

export default CustomTabs;
